import React from 'react';
import {
  Alert,
} from "tabler-react";

function AlertComponent(props){
    const {alert,auth} = props;
    const fixed_classes = 'col mx-auto col-xs-12 col-sm-12 col-md-12 col-lg-12';
    const classes = !!(auth) ? fixed_classes+' col-login' :  fixed_classes;
    return(
        <div className={classes}>
          <Alert type={`${alert.type}`}>
            {alert.message}
          </Alert>
        </div>
    );
}
export default AlertComponent;